import FormComponent from './FormComponent';

export default FormComponent;
